import { observer } from 'mobx-react-lite';
import { DataGrid, NoItemsBox, Page, PromiseContainer } from '../../components';
import { useStore } from '../../store';
import usePromise from '../../store/utils/usePromise';
import createColumns from './components/createColumns';
import Toolbar from './components/Toolbar';

const columns = createColumns();

export default observer(function PromotionsPage() {
  const { promotionStore } = useStore();
  const [promotionsPromise] = usePromise(() =>
    promotionStore.fetchAllPromotions(),
  );
  return (
    <Page>
      <PromiseContainer promise={promotionsPromise}>
        {(promotions) => (
          <>
            <Toolbar promotions={promotions} />
            <DataGrid columns={columns} data={promotions.filteredItems} />
            {promotions.items.length === 0 && (
              <NoItemsBox itemsName="promotions" sx={{ mt: 2 }} />
            )}
          </>
        )}
      </PromiseContainer>
    </Page>
  );
});
